import { useStore } from '@/store/store';
import { useEffect, useRef } from 'react';
import { cleanupBodyScrollLock, lockBodyScroll, unlockBodyScroll } from '@/utils/scroll/scroll';

export const useIsPopupOpen = () => {
    const type = useStore((state) => state.popup.activePopup?.type);
    const scrollYRef = useRef(0);
    const wasOpenRef = useRef(false);

    useEffect(() => {
        if (type) {
            lockBodyScroll(scrollYRef);
            wasOpenRef.current = true;
        } else if (wasOpenRef.current) {
            unlockBodyScroll(scrollYRef);
            wasOpenRef.current = false;
        }

        return () => {
            cleanupBodyScrollLock();
        };
    }, [type]);
};
